"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Filter = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = require("lodash");

var types = _interopRequireWildcard(require("../SmartTable/constants"));

var _material = require("@mui/material");

var _IconBtnTooltip = _interopRequireDefault(require("../IconBtnTooltip"));

require("./styles.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Filter = /*#__PURE__*/function (_Component) {
  _inherits(Filter, _Component);

  var _super = _createSuper(Filter);

  function Filter() {
    var _this;

    _classCallCheck(this, Filter);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      filterMenuAnchor: null,
      selectedFilters: {},
      uniqueFilterLists: {}
    });

    _defineProperty(_assertThisInitialized(_this), "getUniqueFilterList", function () {
      var _this$props = _this.props,
          columns = _this$props.columns,
          data = _this$props.data;
      var uniqueFilterLists = {}; // sets unique filter list

      data.forEach(function (row, index) {
        columns.forEach(function (column) {
          var canFilter = column.canFilter !== undefined ? column.canFilter : true;

          if (canFilter) {
            // canFilter can be used to exclude columns for filter lists
            var filterList = uniqueFilterLists[column.key] || [];
            var skipSorting = false;

            if (column.statusOptions !== undefined || column.customFilterList !== undefined) {
              var filterOptions = column.customFilterList || column.statusOptions;
              filterList = filterOptions.map(function (option) {
                return option.display || option.value || option;
              });
              skipSorting = true; // no need to sort custom provided filter lists
            } else if (!filterList.includes(row[column.key]) && row[column.key]) {
              // only add in row item, if not already in the unique filter list and value exists
              filterList.push(row[column.key]);
            }

            if (index === data.length - 1 && !skipSorting) {
              // sort filterList on last row, skip custom lists
              filterList = _this.dataSorter(column.type, filterList);
            }

            if (filterList.length > 0) uniqueFilterLists[column.key] = filterList; // only add as filter option if list has at least one value
          }
        });
      });

      _this.setState({
        uniqueFilterLists: uniqueFilterLists
      });
    });

    _defineProperty(_assertThisInitialized(_this), "clearSelectedFilters", function () {
      var _this$props2 = _this.props,
          columns = _this$props2.columns,
          onFilterReset = _this$props2.onFilterReset;
      var selectedFilters = {}; // sets beginning selectedFilters as all empty

      columns.forEach(function (column) {
        return selectedFilters[column.key] = [];
      });

      _this.setState({
        selectedFilters: selectedFilters
      });

      onFilterReset(selectedFilters);
    });

    _defineProperty(_assertThisInitialized(_this), "onFilterSelection", function (e, key) {
      var selectedFilters = (0, _lodash.cloneDeep)(_this.state.selectedFilters);
      selectedFilters[key] = e.target.value; // set selected filters (array) based on the column title

      _this.setState({
        selectedFilters: selectedFilters
      });

      _this.props.onFilterChange(selectedFilters, key);
    });

    _defineProperty(_assertThisInitialized(_this), "dataSorter", function (dataType, array) {
      array.sort(function (data1, data2) {
        var endArray = [null, undefined, ''];

        if (endArray.includes(data1) && endArray.includes(data2)) {
          return data1 === null && data2 !== null ? 1 : -1;
        }

        if (endArray.includes(data1)) return 1;
        if (endArray.includes(data2)) return -1;

        switch (dataType) {
          case types.DATE_STRING:
          case types.STRING:
            {
              data1 = data1.toLowerCase();
              data2 = data2.toLowerCase();

              if (data1 < data2) {
                return -1;
              } else if (data1 > data2) {
                return 1;
              }

              return 0;
            }

          case types.DATE_TIME:
            data1 = Date.parse(data1);
            data2 = Date.parse(data2);

            if (data2 > data1) {
              return 1;
            } else if (data2 < data1) {
              return -1;
            }

            return 0;

          case types.CURRENCY:
          case types.DATE:
          case types.NUMBER:
            {
              return data2 - data1;
            }

          case types.BOOLEAN:
            {
              if (data1 && !data2) {
                return 1;
              } else if (data2 && !data1) {
                return -1;
              }

              return 0;
            }

          default:
            return 0;
        }
      });
      return array;
    });

    return _this;
  }

  _createClass(Filter, [{
    key: "renderFilter",
    value: function renderFilter() {
      var _this2 = this;

      var columns = this.props.columns;
      var _this$state = this.state,
          selectedFilters = _this$state.selectedFilters,
          uniqueFilterLists = _this$state.uniqueFilterLists;
      var displayFilter = '';

      if (Object.keys(uniqueFilterLists).length === 1) {
        // use simple filter
        var _Object$entries$ = _slicedToArray(Object.entries(uniqueFilterLists)[0], 2),
            key = _Object$entries$[0],
            filterList = _Object$entries$[1];

        var columnTitle = columns.find(function (column) {
          return column.key === key;
        }).title;
        displayFilter = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
          className: "Filter_simpleHeader"
        }, /*#__PURE__*/_react["default"].createElement("div", null, columnTitle), /*#__PURE__*/_react["default"].createElement(_material.Button, {
          color: "primary",
          variant: "text",
          onClick: this.clearSelectedFilters,
          size: "medium",
          style: {
            marginTop: '5px'
          }
        }, "RESET")), /*#__PURE__*/_react["default"].createElement("div", {
          className: "Filter_simpleList"
        }, filterList.map(function (filter) {
          var isSelected = selectedFilters[key].indexOf(filter) > -1;
          return /*#__PURE__*/_react["default"].createElement(_material.MenuItem, {
            key: filter,
            value: filter,
            onClick: function onClick() {
              var value = isSelected ? selectedFilters[key].filter(function (selectedFilter) {
                return selectedFilter !== filter;
              }) : [].concat(_toConsumableArray(selectedFilters[key]), [filter]);

              _this2.onFilterSelection({
                target: {
                  value: value
                }
              }, key);
            }
          }, /*#__PURE__*/_react["default"].createElement(_material.Checkbox, {
            checked: isSelected
          }), /*#__PURE__*/_react["default"].createElement(_material.ListItemText, {
            primary: filter
          }));
        })));
      } else {
        // default with multiple dropdown options
        displayFilter = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
          className: "Filter_header"
        }, /*#__PURE__*/_react["default"].createElement("span", null, "FILTERS"), /*#__PURE__*/_react["default"].createElement(_material.Button, {
          color: "primary",
          variant: "text",
          onClick: this.clearSelectedFilters,
          size: "medium",
          style: {
            marginLeft: '15px'
          }
        }, "RESET")), /*#__PURE__*/_react["default"].createElement("div", {
          className: "Filter_options"
        }, Object.entries(uniqueFilterLists).map(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
              key = _ref2[0],
              filterList = _ref2[1];

          var columnTitle = columns.find(function (column) {
            return column.key === key;
          }).title;
          return /*#__PURE__*/_react["default"].createElement(_material.FormControl, {
            className: "Filter_list",
            key: key,
            variant: "standard"
          }, /*#__PURE__*/_react["default"].createElement(_material.InputLabel, {
            id: "demo-mutiple-checkbox-label"
          }, columnTitle), /*#__PURE__*/_react["default"].createElement(_material.Select, {
            labelId: "demo-mutiple-checkbox-label",
            id: "demo-mutiple-checkbox",
            multiple: true,
            value: selectedFilters[key] || [],
            onChange: function onChange(e) {
              return _this2.onFilterSelection(e, key);
            },
            input: /*#__PURE__*/_react["default"].createElement(_material.Input, null),
            renderValue: function renderValue(selected) {
              return selected.join(', ');
            }
          }, filterList.map(function (filter) {
            return /*#__PURE__*/_react["default"].createElement(_material.MenuItem, {
              key: filter,
              value: filter
            }, /*#__PURE__*/_react["default"].createElement(_material.Checkbox, {
              checked: selectedFilters[key].indexOf(filter) > -1
            }), /*#__PURE__*/_react["default"].createElement(_material.ListItemText, {
              primary: filter
            }));
          })));
        })));
      }

      return displayFilter;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this3 = this;

      this.getUniqueFilterList();
      var selectedFilters = this.props.selectedFilters;

      if (!(0, _lodash.isEmpty)(selectedFilters)) {
        this.setState({
          selectedFilters: selectedFilters
        }, function () {
          return _this3.props.onFilterChange(_this3.state.selectedFilters);
        });
      } else this.clearSelectedFilters();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props3 = this.props,
          columns = _this$props3.columns,
          data = _this$props3.data,
          keepSelectedFilters = _this$props3.keepSelectedFilters,
          selectedFilters = _this$props3.selectedFilters;
      var selectedFiltersNotLoaded = (0, _lodash.isEmpty)(this.state.selectedFilters);
      var loadExistingSelectedFilters = selectedFiltersNotLoaded && !(0, _lodash.isEmpty)(selectedFilters);
      var selectedFiltersHasUpdated = !(0, _lodash.isEqual)(selectedFilters, prevProps.selectedFilters);
      var previouslyNoData = prevProps.data.length === 0;
      var dataChanged = prevProps.columns.length !== columns.length || prevProps.data.length !== data.length;
      dataChanged && this.getUniqueFilterList(); // make sure unique filter list is generated, if data ever changes

      if (dataChanged && loadExistingSelectedFilters || selectedFiltersHasUpdated) this.setState({
        selectedFilters: selectedFilters
      }); // loading existing selectedFilters list
      else if (dataChanged && !previouslyNoData && !keepSelectedFilters || selectedFiltersNotLoaded) this.clearSelectedFilters(); // otherwise, generate blank filter list
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props4 = this.props,
          disabled = _this$props4.disabled,
          iconButtonTitle = _this$props4.iconButtonTitle,
          iconButtonProps = _this$props4.iconButtonProps;
      var _this$state2 = this.state,
          filterMenuAnchor = _this$state2.filterMenuAnchor,
          uniqueFilterLists = _this$state2.uniqueFilterLists,
          selectedFilters = _this$state2.selectedFilters;
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_IconBtnTooltip["default"], {
        buttonProps: _objectSpread({
          color: 'primary',
          style: {
            marginRight: '5px'
          },
          disabled: disabled
        }, iconButtonProps),
        onClick: function onClick(event) {
          return _this4.setState({
            filterMenuAnchor: event.currentTarget
          });
        },
        icon: "filter_list",
        title: iconButtonTitle
      }), /*#__PURE__*/_react["default"].createElement(_material.Popover, {
        open: Boolean(filterMenuAnchor),
        anchorEl: filterMenuAnchor,
        onClose: function onClose() {
          return _this4.setState({
            filterMenuAnchor: null
          });
        },
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'center'
        },
        transformOrigin: {
          vertical: 'top',
          horizontal: 'right'
        },
        PaperProps: {
          style: {
            width: Object.keys(uniqueFilterLists).length === 1 ? 'auto' : '800px',
            padding: '25px'
          }
        }
      }, !(0, _lodash.isEmpty)(selectedFilters) && this.renderFilter()));
    }
  }]);

  return Filter;
}(_react.Component);

exports.Filter = Filter;

_defineProperty(Filter, "propTypes", {
  columns: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    canFilter: _propTypes["default"].bool,
    customFilterList: _propTypes["default"].array,
    key: _propTypes["default"].string.isRequired,
    statusOptions: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      value: _propTypes["default"].isRequired,
      display: _propTypes["default"].string
    })),
    title: _propTypes["default"].string.isRequired
  })).isRequired,
  data: _propTypes["default"].array.isRequired,
  disabled: _propTypes["default"].bool,
  iconButtonTitle: _propTypes["default"].string,
  onFilterChange: _propTypes["default"].func.isRequired,
  onFilterReset: _propTypes["default"].func.isRequired,
  selectedFilters: _propTypes["default"].object,
  iconButtonProps: _propTypes["default"].object,
  keepSelectedFilters: _propTypes["default"].bool
});

Filter.defaultProps = {
  disabled: false,
  iconButtonTitle: 'Filter',
  selectedFilters: {},
  keepSelectedFilters: false
};
var _default = Filter;
exports["default"] = _default;